export const TRANSLATIONS_RU = {
    auth: {
        marbles: "Мрамор",
        prize: "200,000 ДОЛЛАРОВ ПРИЗЫ",
        title: "Делайте ставки BNB - получайте SQM",
        startBy: "Начните с подключения кошелька",
        connect: "Подключить кошелек",
        incorrectNetwork: {
            title: "Неправильная сеть",
            description: "Чтобы играть в игры Squid Moon, ваш кошелек должен быть в сети Binance Smart Chain.",
            switch: "Переключить сеть"
        }
    },
    header: {
        rank: "Ранг",
        payout: "Выплата",
        connect: "Подключить кошелек",
        prize: "USD В ПРИЗАХ",
        marbles: "Мрамор"
    },
    modals: {
        gameStart: {
            calculate: "Рассчитываются шарики",
            takeUp: "This normally takes 30 seconds but could be 1-2 minutes",
            playAgain: "Играть снова",
            close: "Вы можете закрыть это окно и продолжить игру",
            reimburse: "It is very rare for the bet resolution to fail but if this occurs contact our team and provide your betId of: "
        },
        lost: {
            bet: "Ваша ставка: четное",
            result: "Результат: четное",
            betterLuck: "К сожалению, ты проиграл - повезет в следующий раз"
        },
        marble: {
            marbles: "Мрамор",
            yourBet: "Сделайте ставку в BNB и угадайте, четное или нечетное количество шариков",
            win: "Если вы выиграете, вы получите обратно свою первоначальную ставку в BNB",
            reward: "Вам дается вознаграждение, равное вашей ставке в BNB в токенах $ SQM",
            leaderboard: "Вы продвигаетесь в таблице лидеров",
            lose: "Если вы ошиблись, вы проиграете ставку в BNB, ваш BNB добавляется в призовой фонд, ваш счет не увеличивается"
        },
        noMarble: {
            result: "Результат:",
            noMarbles: "Без шариков",
            partialRefund: "В руке не было шариков, возвращаем 50% ставки"
        },
        selectWallet: {
            connect: "Подключите свой кошелек"
        },
        win: {
            bet: "Ваша ставка: четное",
            result: "Результат: четное",
            congrats: "Поздравляем с победой"
        },
        end: {
            gameOver: "GAME OVER",
            claim: "Claim Winnings",
            payout: "Estimated Payout",
            distributing: "Distributing..."
        }
    },
    preLoader: {
        title: "Представьте первую игру",
        description: "Сделайте ставку в BNB и угадайте, четное или нечетное количество шариков."
    },
    sections: {
        hero: {
            marbles: "Мрамор",
            prize: "USD В ПРИЗАХ",
            even: "Четное",
            odd: "Нечетное",
            betAmount: "Выберите сумму ставки для игры",
            approve: "Подтвердите сделку",
            throughWallet: "через ваш кошелек",
            waiting: "Waiting for tx confirmation",
            confirm: "Transaction confirmed. Waiting for bet resolution...",
            description: "Игры Squid Moon - это децентрализованные приложения на блокчейне BSC. Вы можете просмотреть смарт-контракт",
            here: "слышать",
            failed: "Не удалось",
            notApproved: "Транзакция не одобрена",
            close: "Закрывать",
            pending: "В ожидании",
            or: "или",
            bnbAmount: "Выберите сумму BNB",
            quickPlay: "Включить быструю игру",
            notEnough: "У вас недостаточно BNB в кошельке, чтобы сделать ставку."
        },
        leaderboard: {
            leaderboard: "Таблица лидеров",
            top: "Вверх",
            winner: "Победитель",
            yourScore: "Твой счет",
            prize: "долларов США в виде призов",
            announced: "дней до объявления победителей",
            rank: "Ранг",
            score: "Счет",
            payout: "Расчетная выплата",
            fullLeaderboard: "Посмотреть полную таблицу лидеров",
        },
        prevGame: {
            yourGames: "Ваши предыдущие игры",
            bet: "Ставка:",
            result: "Результат",
            pending: "В ожидании",
            win: "Выиграть",
        }
    }
};
